import * as Yup from "yup";
import i18next from "i18next";

export const AddUserSchema = () => Yup.object({
    role_id: Yup.string().required(i18next.t('user.error_role')),
    type_id: Yup.string().required(i18next.t('user.error_user_type')),
    fname: Yup.string().required(i18next.t('user.error_fname')),
    lname: Yup.string().required(i18next.t('user.error_lname')),
    mobile: Yup.string()
        .required(i18next.t('user.error_mobile'))
        .matches(/^[0-9]{10}$/, i18next.t('user.error_invalid_mobile')),
    email: Yup.string()
        .required(i18next.t('user.error_email'))
        .email(i18next.t('user.error_invalid_email')),
    password: Yup.string().required(i18next.t('user.error_password')),
    confirmPassword: Yup.string()
        .required(i18next.t('user.error_confirm_password'))
        .oneOf([Yup.ref('password')], i18next.t('user.error_password_match')),
    country: Yup.string().nullable(),
    state: Yup.string().nullable(),
    city: Yup.string().nullable(),
    pincode: Yup.string()
        .nullable()
        .matches(/^$|^[0-9]{6}$/, i18next.t('user.error_pincode')),
    address: Yup.string().nullable(),
    gender: Yup.string().nullable(),
    dob: Yup.string().nullable(),
    profile: Yup.mixed()
        .test('fileSize', i18next.t('user.error_file_size'), (value) => {
            if (!value) return true;
            return value.size <= 5242880; // 5MB
        })
        .test('fileType', i18next.t('user.error_file_type'), (value) => {
            if (!value) return true;
            return ['image/jpeg', 'image/jpg', 'image/png'].includes(value.type);
        }),
    status: Yup.string().required(i18next.t('user.error_status')),
});

export const UpdateUserSchema = () => Yup.object({
    role_id: Yup.string().required(i18next.t('user.error_role')),
    type_id: Yup.string().required(i18next.t('user.error_user_type')),
    fname: Yup.string().required(i18next.t('user.error_fname')),
    lname: Yup.string().required(i18next.t('user.error_lname')),
    mobile: Yup.string()
        .required(i18next.t('user.error_mobile'))
        .matches(/^[0-9]{10}$/, i18next.t('user.error_invalid_mobile')),
    email: Yup.string()
        .required(i18next.t('user.error_email'))
        .email(i18next.t('user.error_invalid_email')),
    country: Yup.string().nullable(),
    state: Yup.string().nullable(),
    city: Yup.string().nullable(),
    pincode: Yup.string()
        .nullable()
        .matches(/^$|^[0-9]{6}$/, i18next.t('user.error_pincode')),
    address: Yup.string().nullable(),
    gender: Yup.string().nullable(),
    dob: Yup.string().nullable(),
    profile: Yup.mixed()
        .test('fileSize', i18next.t('user.error_file_size'), (value) => {
            if (!value) return true;
            return value.size <= 5242880; // 5MB
        })
        .test('fileType', i18next.t('user.error_file_type'), (value) => {
            if (!value) return true;
            return ['image/jpeg', 'image/jpg', 'image/png'].includes(value.type);
        }),
    status: Yup.string().required(i18next.t('user.error_status')),
});